import { render, staticRenderFns } from "./TpdParticipationList.vue?vue&type=template&id=0a0bc524&"
import script from "./TpdParticipationList.vue?vue&type=script&lang=js&"
export * from "./TpdParticipationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports